<template>
<div>
  <h3 class="page-header">Gallery</h3>
  <div class="gallery-box">
    <div class="row">
      <template v-for="imageUrl in galleryImages">
        <div :key="imageUrl" class="col-12 col-sm-6 col-md-4">
          <img :src="imageUrl" class="gallery-image" alt="Gallery Image" aria-label="Gallery Image"/>
        </div>
      </template>
    </div>
  </div>
</div>
</template>

<script>
import { dataGalleryImages } from '../data'
export default {
  name: 'Gallery',
  metaInfo: {
    title: 'Red Rooster Bistro',
    titleTemplate: '%s | Gallery',
    meta: [
      {
        name: 'description',
        content: 'View our gallery - Quiet French-American bistro in the heart of the North Fork\'s wine country.'
      }
    ]
  },
  data: function () {
    return {
      // upload gallery image in 400px x 400px
      galleryImages: dataGalleryImages
    }
  }
}
</script>

<style scoped>
.gallery-image {
  margin-right: 15px;
  margin-bottom: 30px;
  max-height: 100%;
  max-width: 100%;
}

.page-header {
  margin-bottom: 40px;
}

@media only screen and (max-width: 600px) {
  .gallery-box {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue